import React, { FC, useState } from "react"
import { SearchField } from "dash-styled"

interface SearchCustomersProps {
    searchEmail?: string
    onSearch: (searchEmail: string) => void
}

export const SearchCustomers: FC<SearchCustomersProps> = ({
    searchEmail,
    onSearch
}) => {
    const [value, setValue] = useState<string | undefined>(searchEmail)

    const handleClickSubmit = () => onSearch(value ?? "")

    return (
        <div className="w-1/2 rounded-xl border border-solid border-smoke-340 bg-marketplace-bg-search">
            <SearchField
                transparent={true}
                value={value}
                onChange={setValue}
                onSubmit={handleClickSubmit}
                placeholder={"Enter email"}
            />
        </div>
    )
}
